import React from "react";

function NavbarAdminDetails() {
  return <div className="editor-navbar-details-container" />;
}

export default NavbarAdminDetails;
